import { Label } from "../Label"
import { StarAnim } from "../StarAnim"
import roundLight from "../../assets/round_light_extra.png"
import styles from './styles.module.scss'
import { ThirtyFriendsIcon } from "../../icons/ThirtyFriendsIcon"


type Props = {
    label: string
}

export const Condition6Art = ({ label }: Props) => {
    return <div className={styles.container}>
        <div className={styles.iconWrap}>
            <ThirtyFriendsIcon />
        </div>
        <img src={roundLight} alt="" className={styles.roundLight} />
        <Label label={label} />
        <div className={styles.starAnimWrap}>
            <StarAnim width={140} height={140} className={styles.starAnim} />
        </div>
    </div>
}